import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addModule } from '../../../moduleLoader/actions';
import { getExternalModules } from './actions';
import ExternalModuleFrame from './connectedFrame';
import { CORE_MODULE_NAME, EXTERNAL_MODULE_FRAME_COMPONENT } from './constants';

/**
 * Renders nothing. Fetches the external modules whenever the active program changes, which
 * covers login, a restored session and a program switch with one code path. Also publishes
 * the frame component so other modules can show an external module inside their own screens.
 */
const ExternalModulesLoader = ({ programId, isPMI, actions }) => {
  useEffect(() => {
    actions.addModule(CORE_MODULE_NAME, {
      components: { [EXTERNAL_MODULE_FRAME_COMPONENT]: ExternalModuleFrame },
      routes: { pmiRoutes: {}, rcRoutes: {} },
    });
  }, []);

  useEffect(() => {
    if (programId && !isPMI) {
      actions.getExternalModules();
    }
  }, [programId, isPMI]);
  return null;
};

ExternalModulesLoader.propTypes = {
  programId: PropTypes.number,
  isPMI: PropTypes.bool,
  actions: PropTypes.shape({
    getExternalModules: PropTypes.func.isRequired,
    addModule: PropTypes.func.isRequired,
  }).isRequired,
};

ExternalModulesLoader.defaultProps = {
  programId: undefined,
  isPMI: false,
};

const mapStateToProps = (state) => {
  const program = state.UserDetail.get('currentActiveProgram');
  const userDetail = state.UserDetail.get('userDetail');
  return {
    programId: program ? program.programId : undefined,
    isPMI: !!(userDetail && userDetail.pmiplatform),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ getExternalModules, addModule }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExternalModulesLoader);

export const ExternalModulesLoaderComponent = ExternalModulesLoader;
